import * as Yup from "yup";
import formFieldAdiantamento from "./fieldAdiantamento";

const {
  id,
  urlComprovante,
  nomeResponsavel,
  solicitante,
  dataSolicitacao,
  identificacaoTransacao,
  valorTransacao,
  dataPagamento,
  status,
  celPhone,
  obs,
  contaFinanceiraId,
} = formFieldAdiantamento;

const validationAdiantamento = Yup.object().shape({
  [id.name]: Yup.string().optional(),
  [urlComprovante.name]: Yup.string().optional(),
  [nomeResponsavel.name]: Yup.string().required(nomeResponsavel.errorMsg),
  [solicitante.name]: Yup.string().required(solicitante.errorMsg),
  [dataSolicitacao.name]: Yup.date().required(dataSolicitacao.errorMsg),
  [identificacaoTransacao.name]: Yup.string().required(
    identificacaoTransacao.errorMsg
  ),
  [valorTransacao.name]: Yup.string().required(valorTransacao.errorMsg),
  [dataPagamento.name]: Yup.date().when(status.name, {
    is: "Pago",
    then: (schema) => schema.required("Informe a data de pagamento."),
    otherwise: (schema) => schema.optional().nullable(),
  }),
  [status.name]: Yup.string().required(status.errorMsg),
  [celPhone.name]: Yup.string().optional(),
  [obs.name]: Yup.string().optional(),
  [contaFinanceiraId.name]: Yup.string().when(status.name, {
    is: "Pago",
    then: (schema) => schema.required(contaFinanceiraId.errorMsg),
    otherwise: (schema) => schema.optional(),
  }),
});

export { validationAdiantamento };
